import { useTranslation } from 'react-i18next';
import type { Optional } from '@/generic/functional';
import type { OrganizationId } from '@/rule/domain/OrganizationId.ts';

export const useOrganizationText = (organizationId: Optional<OrganizationId>): string => {
  const { t } = useTranslation('rule');

  return organizationId
    .map((organizationId) => organizationId.value)
    .orElseGet(() => t('rule.organization.default'));
};
